import axios from "axios";
import config from "./config"; // the config file we created earlier
import { clearAuthToken, getAuthToken } from "../utils/storageKeys";

// Create Axios instance
const api = axios.create({
  baseURL: config.apiUrl, // base URL for all requests
  timeout: 300000, // 5 minutes timeout for large file uploads/processing (300000ms = 5min)
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add request interceptor to attach extra headers
api.interceptors.request.use(
  (request) => {
    // Add custom headers here
    const token = getAuthToken();
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete request.headers["Authorization"];
    }

    // Example: add extra data
    request.headers["X-App-Source"] = "ReactFrontend";

    // Prevent browser caching for session-specific data endpoints
    // These can change frequently (corner reassignment, etc.) and stale data causes issues
    const url = request.url || '';
    if (url.includes('/aim/session/') && (url.includes('/data') || url.includes('/track-svg') || url.includes('/corner/'))) {
      request.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
      request.headers["Pragma"] = "no-cache";
      request.headers["Expires"] = "0";
    }

    return request;
  },
  (error) => Promise.reject(error)
);

// Optional: response interceptor for handling errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // On 401 (expired/invalid token) clear stored auth and send the user to login.
    // Skip auth attempts and the login page itself to avoid redirect loops.
    const status = error.response?.status;
    const requestUrl = error.config?.url || "";
    const isAuthAttempt =
      requestUrl.includes("/auth/login") ||
      requestUrl.includes("/auth/register") ||
      requestUrl.includes("/auth/apple");
    if (status === 401 && !isAuthAttempt) {
      clearAuthToken();
      delete api.defaults.headers.common["Authorization"];
      if (!window.location.pathname.startsWith("/Laptura/login")) {
        window.location.assign("/Laptura/login");
      }
    }
    console.error("API error:", error);
    return Promise.reject(error);
  }
);

export default api;
